import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { TestSuiteIssueTableFilterSchema } from './-zod-schema';

// テストスイート詳細 > 不具合タブ。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// 遅延ロードして bundle 分割する（他のタブ・ページと同じ規約）。
export const Route = createFileRoute(
  '/_stacktrace/test-suites/$id/_layout/issues/',
)({
  validateSearch: zodValidator(TestSuiteIssueTableFilterSchema),
});
